import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { executeWithAuthRetry } from '@/utils/sessionUtils';

export const useActivities = (programId?: string, enabled = true) => {
  
  const query = useQuery({
    queryKey: ['activities', programId],
    queryFn: async () => {
      
      if (!programId) {
        return [];
      }
      
      
      const result = await executeWithAuthRetry(async () => {
        return await supabase
          .from('activities')
          .select('*')
          .eq('program_id', programId)
          .order('order_index', { ascending: true });
      });

      if (result.error) {
        console.error('❌ useActivities database error:', result.error);
        throw result.error;
      }
      
      
      return result.data || [];
    },
    enabled: enabled && !!programId,
    retry: (failureCount, error: unknown) => {
      const err = error as { code?: string };
      // Don't retry auth errors since executeWithAuthRetry handles them
      if (err?.code === 'PGRST301') return false;
      return failureCount < 2;
    },
  });

  // Return empty array when no programId provided, but preserve error states
  if (!programId && enabled) {
    return {
      ...query,
      data: [] as any[]
    };
  }
  
  return query;
};